import { useEffect, useState } from 'react'
import { getbulk, gettoken } from '../Localstorage/Store';
import Error from '../pages/Error/Error';


const RedirectionComp = ({page,bulk=false}) => {
    const bulkstatus = getbulk()
    const [tok,setTok] = useState(false)
    const [bulkStatus,setbulkStatus] = useState(false)
    useEffect(()=>{
        setTok(gettoken())
        if(bulk && bulkstatus){
          setbulkStatus(true)
        }
    },[bulk])


  if(!bulkStatus){
  return (tok == false ? null:tok==undefined? <Error /> : page)
  }else{
  return (tok == false ? null:tok==undefined? <Error /> : page)
  }
}

export default RedirectionComp